import React, { useEffect, useState } from "react";
import { useParams, useNavigate , useLocation} from "react-router-dom";
import OTGToolbar from "./OTGToolBar";
import {toast, ToastContainer} from "react-toastify";
import {Tooltip} from "react-tooltip";
import GPSCoordinateInput from "./components/GpsCoordinateInput";


const RevenueViewEvent = () => {
    const location = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [ searchTerm] = useState(location.state?.searchTerm || null);
    const [filters] = useState(location.state?.filters || {});

    const openForum = (url) =>{
        window.open(url, '_blank').focus();
    }

    useEffect(() => {
        const fetchEvent = async () => {
            try {
                setLoading(true);
                const response = await fetch(`/otgservices/getOTGEvents.php?id=${id}`);
                if (!response.ok) throw new Error("Failed to fetch event");
                const data = await response.json();
                if ( data.rows.length) {
                    setEvent(data.rows[0])
                    setCurrentUserId(data.rows[0].currentuserid);
                }
                else {
                    setError('The event was Not found');
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchEvent();
    }, [id]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";

        const [year, month, day] = dateStr.split('-');
        return new Date(year, month - 1, day).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };


    const handlePrivateJoin = async () => {

        if ( currentUserId === null || ( currentUserId === "" || currentUserId.length === 0) ) {
            toast.error("You need to be logged in! Please go to www.overlandtrailguides.com");
            return;
        }

        const eventType = event.eventtype;
        // If admin has sus-ended subscriptions do NOT check for subscriptions
        if ( event.suspendsubs) {
            if (eventType === "Meetup" || eventType.includes("Volunteer")) {
                navigate(`/events/sm-join-event/${event.id}/${currentUserId}`, {state: {event : event, userId : currentUserId}});
            } else {
                navigate(`/events/join-event/${event.id}/${currentUserId}`, {state: {event, userId : currentUserId}});
            }
            return;
        }


        fetch('/otgservices/checkSubscription.php')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(json => {
                if (!json.success) {
                    toast.error("You must have a subscription to Join. Please go to www.overlandtrailguides.com and subscribe");
                    return;
                }
                if (eventType === "Meetup" || eventType.includes("Volunteer")) {
                    navigate(`/events/sm-join-event/${event.id}/${currentUserId}`, {state: {event : event, userId : currentUserId}});
                } else {
                    navigate(`/events/join-event/${event.id}/${currentUserId}`, {state: {event, userId : currentUserId}});
                }
            })
            .catch(error => {
                console.error('Error checking subscription:', error);
                toast.error("Error checking subscription status. Please try again.");
            });

    };


    const openSpecialPage = (url) => {
        window.open(url, '_blank').focus();
    }


    if (loading) return <div className="p-6 text-center">Loading event...</div>;
    if (error) return <div className="p-6 text-center text-red-500">Error: {error}</div>;
    if (!event) return <div className="p-6 text-center">Event not found.</div>;

    return (
        <div className="p-4 sm:p-6 bg-gray-100 min-h-screen">
            <ToastContainer/>
            <OTGToolbar/>
            <div className="max-w-7xl mx-auto">
                <h2 className="text-2xl font-bold mb-6 py-2 text-center">View Event</h2>

                <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                    {/* Event Image Section - Full Width */}
                    {event.imageurl && (
                        <div className="w-full">
                            <div className="relative w-full bg-gray-100">
                                <img
                                    src={event.imageurl}
                                    alt="Event"
                                    className="w-full h-64 sm:h-80 md:h-96 lg:h-[32rem] xl:h-[36rem] object-cover"
                                    style={{imageRendering: 'high-quality'}}
                                />
                            </div>
                        </div>
                    )}

                    <div className="p-6">
                        {/* Event Name - Full Width */}
                        <div className="mb-6 text-center">
                            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
                                {event.name}
                            </h1>
                        </div>

                        {/* Main Content Grid */}
                        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
                            {/* Left Column - Event Details */}
                            <div className="xl:col-span-2 space-y-6">
                                {/* Date and Time Section */}
                                <div className="bg-gray-50 p-4 rounded-lg">
                                    <h3 className="text-lg font-semibold mb-4 text-gray-800">Event Schedule</h3>
                                    <div className="grid grid-cols-2 gap-4">
                                        <Field label="Start Date" value={formatDate(event.start_time)}/>
                                        <Field label="End Date" value={formatDate(event.end_time)}/>
                                        <Field label="Start Time" value={event.begin_hour_time}/>
                                        <Field label="End Time" value={event.end_hour_time}/>
                                    </div>
                                </div>

                                {/* Event Summary */}
                                <div>
                                    <Field label="Event Summary" value={event.summary} multiline/>
                                </div>

                                {/* Event Options */}
                                <div className="bg-blue-50 p-4 rounded-lg">
                                    <h3 className="text-lg font-semibold mb-3 text-gray-800">Event Options</h3>
                                    <div className="flex flex-wrap gap-4">
                                        <span className="bg-white px-3 py-2 rounded-md shadow-sm">
                                            Children: <strong className={event.children_permitted ? "text-green-600" : "text-red-600"}>
                                                {event.children_permitted ? "Yes" : "No"}
                                            </strong>
                                        </span>
                                        <span className="bg-white px-3 py-2 rounded-md shadow-sm">
                                            Dogs: <strong className={event.dogs_permitted ? "text-green-600" : "text-red-600"}>
                                                {event.dogs_permitted ? "Yes" : "No"}
                                            </strong>
                                        </span>
                                        <span className="bg-white px-3 py-2 rounded-md shadow-sm">
                                            Public: <strong className={event.is_public ? "text-green-600" : "text-red-600"}>
                                                {event.is_public ? "Yes" : "No"}
                                            </strong>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column - Location Details */}
                            <div className="space-y-6">
                                {/* Location Section */}
                                <div className="bg-green-50 p-4 rounded-lg">
                                    <h3 className="text-lg font-semibold mb-4 text-gray-800">Location</h3>
                                    <div className="space-y-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-1 gap-4">
                                            <Field label="Region" value={event.region}/>
                                            <Field label="State" value={event.location}/>
                                        </div>
                                        <Field label="Meet Instructions" value={event.meetup_location}/>
                                        {event.gpscoordinate && (
                                            <div className="space-y-2">
                                                <Field label="Meet Address/GPS" value={event.meetaddress}/>
                                                <GPSCoordinateInput
                                                    value={event.gpscoordinate}
                                                    className="w-full"
                                                    readOnly={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                {event.revenueevent && (
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 py-6">

                        {( event.forumurl ) && (
                            <button
                                type="button"
                                onClick={() => openForum(event.forumurl)}
                                className="w-full sm:w-auto bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors"
                            >
                                Forum
                            </button>
                        )}
                        <button
                            onClick={() => {
                                const lroute = '/events/#event-' + event.id;
                                navigate(lroute, {
                                    state: {
                                        action   : 'refresh',
                                        timestamp: Date.now(),
                                        searchTerm : searchTerm,
                                        filters : filters
                                    }
                                })
                            }}
                            className="w-full sm:w-auto bg-gray-300 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-400 transition-colors"
                        >
                            Back
                        </button>

                        <button
                            onClick={() => {
                                openSpecialPage(event.specialeventurl)
                            }}
                            className="w-full sm:w-auto bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors"
                        >
                            Event Details
                        </button>

                        {(!event.is_public && !event.isgoing) && (
                            <span id="join-private-event-tt" className="w-full sm:w-auto">
                                <button
                                    onClick={handlePrivateJoin}
                                    className="w-full bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-colors"
                                >
                                    Join
                                </button>
                                <Tooltip
                                    anchorSelect="#join-private-event-tt"
                                    place="top"
                                    content="Join this private event"
                                />
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

const Field = ({label, value, multiline = false, featured = false}) => {
    // Custom styling for technical rating field
    let customStyle = {};
    let containerClass = "";

    if (label === "Technical Rating" && value !== null && value !== undefined) {
        const rating = parseInt(value);
        if (!isNaN(rating)) {
            if (rating < 4) {
                customStyle = {backgroundColor: '#07a554'}; // Light green
            } else if (rating >= 4 && rating <= 7) {
                customStyle = {backgroundColor: '#2265bd'}; // Light blue
            } else if (rating >= 8) {
                customStyle = {backgroundColor: '#1f2937', color: 'white'}; // Dark with white text
            }
        }
    }

    if (label === "Event Summary") {
        customStyle = {
            border: '1px solid #e5e7eb', // Small light gray border
            margin: '0'
        };
    }

    if (featured) {
        containerClass = "text-center";
    }

    return (
        <div className={containerClass}>
            <label className={`block mb-2 font-bold ${featured ? "text-xl sm:text-2xl text-gray-800" : "text-sm text-gray-700"}`}>
                {label}
            </label>
            <div
                className={`px-3 py-2 rounded-md bg-white ${multiline ? "min-h-20" : ""} ${featured ? "text-lg border-2 border-gray-200" : "border border-gray-200"}`}
                style={customStyle}
            >
                {value || ""}
            </div>
        </div>
    );
};

export default RevenueViewEvent;